<mat-dialog-content class="overflow-hidden">
    <div class="flex flex-row justify-end">
        <button mat-icon-button (click)="dialogRef.close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="flex flex-row w-full mb-6" *ngIf="project && projectHistory">
        <div class="flex flex-col w-[15em]">
            <div class="bold mb-2 text-xs">{{ 'JOB_NAME' | translate }}</div>
            <div class="value bold line-clamp-2 overflow-hidden text-ellipsis">{{ project.identifier }} - {{ project.custom.general.id_codearticle || project.custom.general.designation }}</div>
        </div>
        <div class="flex flex-col w-[10em]">
            <div class="bold mb-2 text-xs">{{ 'PROJECT.INFO.CUSTOMER' | translate }}</div>
            <div class="value">{{ project.custom.general_info.customer.name }}</div>
        </div>
        <!-- <app-project-proofreadings-statuses [proofreadings]="getExternProofreadingsFromProjectHistories()"></app-project-proofreadings-statuses> -->
    </div>
    <div class="font-extralight italic">
        <span>{{ 'DASHBOARDHISTORY.VALIDATIONS_HISTORY' | translate }}</span>
    </div>
    <div class="flex flex-row" *ngIf="!loading">
        <app-flows-version-selector class="max-h-[24rem] overflow-y-auto" dashboard (versionSelected)="updateVersion($event)" [mode]="mode"></app-flows-version-selector>
        <app-history-detail class="flex-grow pl-4 min-w-[40rem]"></app-history-detail>
    </div>
    <div class="flex flex-row w-[855px] justify-center items-center" *ngIf="loading">
        <app-loader *ngIf="loading" class="global-loader" [loading]="loading"></app-loader>
    </div>
</mat-dialog-content>